<template>
  <div style="min-height: 70px" v-if="password && !isValid && message">
    <b-alert
      show
      variant="light"
      class="password-errors font-green-16 p-2 d-flex justify-content-center"
      :class="{ hide: hide }"
    >
      {{ $t(message) }}
    </b-alert>
  </div>
</template>

<script>
export default {
  props: ["password", "hide", "cofirmPassword", "signUp"],
  data() {
    return {
      numberRegex: /(?=.*\d)/,
      upperLowerRegex: /(?=.*[a-z])(?=.*[A-Z])/,
      specialCharacters: /(?=.*[^\da-zA-Z])/,
      lengthRegex: /(.*)\S{8,12}/,
      spaceRegex: /\s/g,
      upperLowerText: "Please include one uppercase and one lowercase letter",
      numberText: "Please include at least one number",
      specialCharactersText: "Please include at least one special character",
      lengthText: "Make sure the password is at least 8 characters long",
      spaceText: "Make sure the password does not have whitespaces",
      passwordMatchError: "New password and confirm password don't match",
      signUpPasswordMatchError: "Password and repeat password don't match",
    };
  },
  computed: {
    hasNumbers() {
      return this.numberRegex.test(this.password);
    },
    hasUpperLower() {
      return this.upperLowerRegex.test(this.password);
    },
    hasSpecialCharacters() {
      return this.specialCharacters.test(this.password);
    },
    hasLength() {
      return this.lengthRegex.test(this.password);
    },
    hasSpace() {
      return this.spaceRegex.test(this.password);
    },
    passwordMatch() {
      return this.password && this.cofirmPassword
        ? this.password == this.cofirmPassword
        : true;
    },
    isValid() {
      return (
        this.hasLength &&
        this.hasUpperLower &&
        this.hasNumbers &&
        this.hasSpecialCharacters &&
        !this.hasSpace &&
        this.passwordMatch
      );
    },
    message() {
      if (!this.password) {
        return;
      }
      if (!this.hasUpperLower) {
        return this.upperLowerText;
      } else if (!this.hasNumbers) {
        return this.numberText;
      } else if (!this.hasSpecialCharacters) {
        return this.specialCharactersText;
      } else if (!this.hasLength) {
        return this.lengthText;
      } else if (this.hasSpace) {
        return this.spaceText;
      } else if (!this.passwordMatch && this.signUp) {
        return this.signUpPasswordMatchError;
      } else if (!this.passwordMatch && !this.signUp) {
        return this.passwordMatchError;
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss">
.password-errors {
  ul {
    list-style-type: none;
    text-align: center;
    margin-left: 1rem;
    color: red;
    width: 100%;
    // margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    // li:before {
    //   content: "x";
    //   margin-right: 0.5rem;
    // }
  }
}
.password-errors.hide {
  display: none !important;
}
</style>
